import { RootStateTypeExtra } from '@store/types'

const prepareHeaders = (
  headers: Headers,
  { getState }: { getState: () => unknown }
) => {
  const {
    user: { email },
    token: {
      access_token: { token },
    },
  } = getState() as RootStateTypeExtra
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }
  if (email) {
    headers.set('user', email)
  }
  return headers
}

export default prepareHeaders
